import { Button, Card, Flex, Spin, Statistic, Steps, Typography } from "antd";
import { useForm } from "antd/lib/form/Form";
import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import "../../../assets/styles/Bond.css";
import MainLayout from "../../../components/layouts/enhancement/MainLayout";
import TopContent from "../../../components/layouts/enhancement/TopContent";
import cnt from "../../../services/definedConstant";
import { BOM } from "../../../services/definedMethod";
import AccountParametersForm from "./components/add/AccountParametersForm";
import ChannelsAndAccessForm from "./components/add/ChannelsAndAccessForm";
import CustomerEligibilityForm from "./components/add/CustomerEligibilityForm";
import Preview from "./components/add/Preview";
import ProductInformationForm from "./components/add/ProductInformationForm";
import AccountingForm from "./components/enhancement/AccountinForm";
import ChargeForm from "./components/enhancement/ChargeForm";
import FeedbackModal from "./components/FeedbackModal";
import { apiConfig, labelConfig, staticConfig } from "./wallet.config";
// import "../../../assets/styles/InterbankPlacement.css";

import dayjs from "dayjs";
const { Text } = Typography;

const multiFactorAuthenticationOptions = [
  { value: 0, label: "Enable" },
  { value: 1, label: "Disable" },
];

const NewWallet = (props) => {
  const { userData } = props;
  const { session } = userData;
  const { state: selectedBranchKey } = useLocation();
  const navigate = useNavigate();
  const [form] = useForm();
  console.log("selectedBranchKey", selectedBranchKey);

  const [current, setCurrent] = useState(0);
  const [checkedInterestBearing, setCheckedInterestBearing] = useState(false);
  const [checkedActivateWallet, setCheckedActivateWallet] = useState(false);
  const [checkedAllowTokenization, setCheckedAllowTokenization] =
    useState(false);
  const [checkedAllowSubWallet, setCheckedAllowSubWallet] = useState(false);
  const [checkedaccountMaintenanceFee, setCheckedaccountMaintenanceFee] =
    useState(false);
  const [checkedCashInFee, setCheckedCashInFee] = useState(false);
  const [selectedCurrencySymbol, setSelectedCurrencySymbol] = useState("");

  const [checkedCashOutFee, setCheckedCashOutFee] = useState(false);
  const [checkedWalletToWalletTransfer, setCheckedWalletToWalletTransfer] =
    useState(false);
  const [checkedWalletToBankTransfer, setCheckedWalletToBankTransfer] =
    useState(false);
  const [chargesValue, setChargesValue] = useState(null);
  const [isDormancyTrackingActive, setIsDormancyTrackingActive] =
    useState(false);
  const [checkedMobileApp, setCheckedMobileApp] = useState(false);
  const [checkedUSSD, setCheckedUSSD] = useState(false);
  const [checkedWebPortal, setCheckedWebPortal] = useState(false);
  const [checkedATM, setCheckedATM] = useState(false);
  const [checkedPOS, setCheckedPOS] = useState(false);
  const [checkedAPI, setCheckedAPI] = useState(false);
  const [checkedQRCode, setCheckedQRCode] = useState(false);
  const [isLoadingTemplate, setIsLoadingTemplate] = useState(false);
  const [isLoadingCurrency, setIsLoadingCurrency] = useState(false);
  const [radioCheck, setRadioCheck] = useState(true);
  const [mapPenaltyTableSource, setMapPenaltyTableSource] = useState([]);
  const [feeCount, setFeeCount] = useState(0);

  const [checkedCallable, setCheckedCallable] = useState(false);
  const [checkedPutable, setCheckedPutable] = useState(false);
  const [checkedConvertible, setCheckedConvertible] = useState(false);
  const [checkedWitholding, setCheckedWitholding] = useState(false);
  const [checkedSetup, setCheckedSetup] = useState(false);
  const [checkedRedemption, setCheckedRedemption] = useState(false);
  const [checkedTransfer, setCheckedTransfer] = useState(false);
  const [checkedBrokerage, setCheckedBrokerage] = useState(false);
  const [checkedRepaymentType, setCheckedRepaymentType] = useState(false);
  const [chargeTableSource, setChargeTableSource] = useState([]);
  const [equityAccountOptions, setEquityAccountOptions] = useState([]);
  const [liabilityAccountOptions, setLiabilityAccountOptions] = useState([]);
  const [fundCount, setFundCount] = useState(1);
  const [penaltyCount, setPenaltyCount] = useState(0);

  const [successModalVisible, setSuccessModalVisible] = useState(false);
  const [warningModalVisible, setWarningModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  // const [walletAccountOptions,setWalletAccountOptions] = useState([])
  const [feesIncomeOptions, setFeesIncomeOptions] = useState([]);
  const [transferChargesOptions, setTransferChargesOptions] = useState([]);
  const [suspenseAccountOptions, setSuspenseAccountOption] = useState([]);
  const [walletLiabiltyAccountOptions, setWalletLiabiltyAccountOption] =
    useState([]);
  const [charges, setCharges] = useState([]);
  const [chargesOptions, setChargesOptions] = useState([]);
  const [productTypeEnum, setProductTypeEnum] = useState([]);
  const [currency, setCurrency] = useState(null);
  const [externalIdentifiers, setExternalIdentifiers] = useState([]);
  const [useCases, setUseCases] = useState([]);
  const [digitsAfterDecimal, setDigitsAfterDecimal] = useState(null);
  const [inMultiplesOf, setInMultiplesOf] = useState(null);
  const [accountingRuleCheck, setAccountingRuleCheck] = useState("1");
  const [transactionRestriction, setTransactionRestriction] = useState([]);
  const [customerSegmentOptions, setCustomerSegmentOptions] = useState([]);
  const [statementCycleOptions, setStatementCycleOptions] = useState([]);
  const [debitAndcreditGlAccount, setDebitAndcreditGlAccount] = useState([]);
  const [chargeBasedOnCurrencyList, setChargeBasedOnCurrencyList] = useState(
    []
  );
  const [paymentTypeOptions, setPaymentTypeOptions] = useState([]);
  const [penaltyOptions, setPenaltyOptions] = useState([]);

  const [walletData, setWalletData] = useState([]);
  const [kycLevelOptions, setKycLevelOptions] = useState([]);
  const [bondProductDetails, setBondProductDetails] = useState([]);
  const [isStepDisabled, setIsStepDisabled] = useState(true);
  const [productCategoryOptions, setProductCategoryOptions] = useState([]);
  const [currencyOptions, setCurrencyOptions] = useState([]);
  const [issueTypeOptions, setIssueTypeOptions] = useState([]);
  const [bondTypeOptions, setBondTypeOptions] = useState([]);
  const [issuerNameOptions, setIssuerNameOptions] = useState([]);
  const [issuerTypeOptions, setIssuerTypeOptions] = useState([]);
  const [creditRatingOptions, setCreditRatingOptions] = useState([]);
  const [countriesOptions, setCountriesOptions] = useState([]);
  const [issuePriceOptions, setIssuePriceOptions] = useState([]);
  const [couponRateOptions, setCouponRateOptions] = useState([]);
  const [couponFrequencyOptions, setCouponFrequencyOptions] = useState([]);
  const [firstCouponDate, setFirstCouponDate] = useState([]);
  const [maturityDateOptions, setMaturityDateOptions] = useState([]);
  const [ammortizationOptions, setAmmortizationOptions] = useState([]);
  const [repaymentTypeOptions, setRepaymentTypeOptions] = useState([]);
  const [interestCalculationBasisOptions, setInterestCalculationBasisOptions] =
    useState([]);
  const [interestStartDateOptions, setInterestStartDateOptions] = useState([]);
  const [interestPaymentModeOptions, setInterestPaymentModeOptions] = useState(
    []
  );
  const [configureFundTableSource, setConfigureFundTableSource] = useState([]);
  const [expenseAccountOptions, setExpenseAccountOptions] = useState([]);
  const [mapFeeTableSource, setMapFeeTableSource] = useState([]);

  const [witholdingTaxOptions, setWitholdingTaxOptions] = useState([]);
  const [incomeAccountOptions, setIncomeAccountOptions] = useState([]);
  const [assetAccountOptions, setAssetAccountOptions] = useState([]);
  const [filteredAssetAccounts, setFilteredAssetAccounts] = useState([]);
  const [filteredIncomeAccounts, setFilteredIncomeAccounts] = useState([]);
  const [filteredExpenseAccount, setFilteredExpenseAccount] = useState([]);
  const [filteredEquityAccount, setFilteredEquityAccount] = useState([]);
  const [filteredLiabilityAccount, setFilteredLiabilityAccount] = useState([]);

  const [formData, setFormData] = useState({
    productInformation: {
      activateWallet: false,
      allowTokenization: false,
      checkedAllowSubWallet: false,
    },
    customerEligibility: null,
    accountParameters: {
      interestBearing: false,
      isDormancyTrackingActive: false,
    },
    charges: {},
    feesAndCharges: {
      accountMaintenanceFee: false,
      cashInFee: false,
      cashOutFee: false,
      walletToWalletTransfer: false,
      walletToBankTransfer: false,
    },
    interestSettings: null,
    taxAndCharges: {
      witholding: {
        enabled: false,
      },
      brokerage: {
        enabled: false,
      },
      setup: {
        enabled: false,
      },
      redemption: {
        enabled: false,
      },
      transfer: {
        enabled: false,
      },
    },
    account: null,
  });
  const [walletTemplate, setWalletTemplate] = useState([]);

  const [showAdvancedAccounting, setShowAdvancedAccounting] = useState(false);

  useEffect(() => {
    getTemplate();
    if (selectedBranchKey) {
      getWalletById();
    }
  }, []);

  useEffect(() => {
    if (!walletData || chargesOptions.length === 0) return;

    const selectedCurrency = walletData.savingsProductData?.currency?.code;
    if (!selectedCurrency) return;

    const chargeForTableData = chargesOptions.filter(
      (item) => item.currencyCode === selectedCurrency
    );

    setChargeBasedOnCurrencyList(chargeForTableData);
  }, [walletData, chargesOptions]);

  useEffect(() => {
    if (
      walletData &&
      currencyOptions.length > 0 &&
      walletData.savingsProductData?.currency?.code
    ) {
      // set the field value
      form.setFieldsValue({
        currencyCode: walletData.savingsProductData.currency.code,
      });

      // run filter manually
      onChangeCurrency(walletData.savingsProductData.currency.code);
    }
  }, [walletData, currencyOptions]);

  function getTemplate() {
    setIsLoading(true);

    let body = {
      session,
    };

    const url = `${apiConfig.Wallet}/template`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err);
        setIsLoading(false);
      } else {
        const objList = res;
        console.log(objList);
        setBondProductDetails(objList);
        setWalletTemplate(objList);
        let tempProductCategory = [];
        let tempCurrency = [];
        let tempIssueType = [];
        let tempBondType = [];
        let tempIssuerName = [];
        let tempIssuerType = [];
        let tempCreditRating = [];
        let tempCountries = [];
        let tempIssuePrice = [];
        let tempCouponRate = [];
        let tempCouponFrequency = [];
        let tempMaturityDate = [];
        let tempAmmortization = [];
        let tempInterestCalculationBasis = [];
        let tempInterestStartDate = [];
        let tempFirstCouponDate = [];
        let tempInterestPaymentMode = [];
        let tempWitholdingTax = [];
        let tempAssetGlAccounts = [];
        let tempIncomeGlAccounts = [];
        let tempExternalIdentifier = [];
        let tempKyc = [];
        let tempProductType = [];
        let tempUseCase = [];
        let tempCustomerSegmentOptions = [];
        let temptransactionRestriction = [];
        let tempStatementCycleOptions = [];
        let tempExpenseOptions = [];

        // let tempWalletAccount = [];
        let tempDebitAndcreditGlAccount = [];
        let tempFeeIncomeAccount = [];
        let tempTransferCharges = [];
        let tempSuspenseAccount = [];
        let tempWalletLiabilityAccount = [];

        let tempDigitsAfterDecimal = 0;
        let tempInMultiplesOf = 0;
        let tempChargesOption = [];
        let tempChargesOptions = [];
        let tempAssetOptions = [];
        let tempEquityOptions = [];
        let tempLiabilityOptions = [];
        let tempPaymentTypeOptions = [];
        let tempPenaltyOptions = [];

        // =========== PRODUCT INFORMATION =============
        objList?.savingsProductData.currencyOptions?.forEach((element) => {
          tempCurrency.push({
            value: element.code,
            label: element.displayLabel,
            symbol: element.displaySymbol || "",
          });
        });

        tempDigitsAfterDecimal =
          objList?.savingsProductData.currency.decimalPlaces;

        tempInMultiplesOf = objList?.savingsProductData.currency.inMultiplesOf;

        objList?.walletsExternalIdTypes?.forEach((element) => {
          tempExternalIdentifier.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.walletProductTypeTypes?.forEach((element) => {
          tempProductType.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.useCaseTypes?.forEach((element) => {
          tempUseCase.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.savingsProductData?.chargeOptions.forEach((element) => {
          tempChargesOption.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.customerSegmentTypes?.forEach((element) => {
          tempCustomerSegmentOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.transactionRestrictionTypes?.forEach((element) => {
          temptransactionRestriction.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.statementCycleTypes?.forEach((element) => {
          tempStatementCycleOptions.push({
            value: element.id,
            label: element.value,
          });
        });

        objList?.kycLevelTypes?.forEach((element) => {
          tempKyc.push({
            value: element.value,
            label: element.value,
          });
        });

        objList?.countries?.forEach((element) => {
          tempCountries.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.savingsProductData?.accountingMappingOptions?.assetAccountOptions.forEach(
          (element) => {
            tempDebitAndcreditGlAccount.push({
              ...element,
              value: element.id,
              label: element.name,
            });
          }
        );

        objList?.savingsProductData?.accountingMappingOptions?.assetAccountOptions?.forEach(
          (element) => {
            tempAssetOptions.push({
              ...element,
              value: element.id,
              label: element.name,
            });
          }
        );

        objList?.savingsProductData.chargeOptions?.forEach((element) => {
          tempChargesOptions.push({
            value: element.id,
            label: `${element.name}(${element?.currency?.name})`,
            currencyName: element?.currency?.name,
            currencyCode: element?.currency?.code,
          });
        });

        objList?.savingsProductData?.accountingMappingOptions?.liabilityAccountOptions.forEach(
          (element) => {
            tempWalletLiabilityAccount.push({
              ...element,
              value: element.id,
              label: element.name,
            });
          }
        );

        objList?.savingsProductData?.accountingMappingOptions?.liabilityAccountOptions.forEach(
          (element) => {
            tempSuspenseAccount.push({
              ...element,
              value: element.id,
              label: element.name,
            });
          }
        );

        objList?.savingsProductData?.accountingMappingOptions?.incomeAccountOptions.forEach(
          (element) => {
            tempFeeIncomeAccount.push({
              ...element, // Preserve all fields including currencyCode
              value: element.id,
              label: element.name, // Optional: prettier display
            });
          }
        );

        objList?.savingsProductData?.accountingMappingOptions?.incomeAccountOptions.forEach(
          (element) => {
            tempFeeIncomeAccount.push({
              ...element, // Preserve all fields including currencyCode
              value: element.id,
              label: `${element.glCode} (${element.name})`, // Optional: prettier display
            });
          }
        );

        objList?.bondTypes?.forEach((element) => {
          tempBondType.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.bondProductCategories?.forEach((element) => {
          tempProductCategory.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.bondIssueTypes?.forEach((element) => {
          tempIssueType.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.issuers?.forEach((element) => {
          tempIssuerName.push({
            value: element.id,
            label: element.name,
          });
        });

        //
        objList?.issuerTypes?.forEach((element) => {
          tempIssuerType.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.creditRatings?.forEach((element) => {
          tempCreditRating.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.bondIssuePrices?.forEach((element) => {
          tempIssuePrice.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.bondCouponRates?.forEach((element) => {
          tempCouponRate.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.bondCouponFrequencies?.forEach((element) => {
          tempCouponFrequency.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.maturityProceeds?.forEach((element) => {
          tempMaturityDate.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.bondAmortizations?.forEach((element) => {
          tempAmmortization.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.interestCalculationBasisOptions?.forEach((element) => {
          tempInterestCalculationBasis.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.interestStartDates?.forEach((element) => {
          tempInterestStartDate.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.bondCouponFrequencies?.forEach((element) => {
          tempFirstCouponDate.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.bondInterestPaymentModes?.forEach((element) => {
          tempInterestPaymentMode.push({
            value: element.value,
            label: element.text,
          });
        });

        objList?.withholdingTaxOptions?.forEach((element) => {
          tempWitholdingTax.push({
            value: element.id,
            label: element.name,
          });
        });

        objList?.assetGLAccounts?.forEach((element) => {
          tempAssetGlAccounts.push({
            value: element.id,
            label: `${element.glCode} (${element.name})`,
            currency: element.currencyCode,
          });
        });

        objList?.incomeGlAccounts?.forEach((element) => {
          tempIncomeGlAccounts.push({
            value: element.id,
            label: `${element.glCode} (${element.name})`,
            currency: element.currencyCode,
          });
        });

        objList?.savingsProductData?.accountingMappingOptions?.equityAccountOptions?.forEach(
          (element) => {
            tempEquityOptions.push({
              value: element.id,
              label: element.name,
            });
          }
        );

        objList?.savingsProductData?.paymentTypeOptions?.forEach((element) => {
          tempPaymentTypeOptions.push({
            ...element,
            value: element.id,
            label: element.name,
          });
        });

        objList?.savingsProductData?.accountingMappingOptions?.expenseAccountOptions?.forEach(
          (element) => {
            tempExpenseOptions.push({
              ...element,
              value: element.id,
              label: element.name,
            });
          }
        );

        objList?.savingsProductData?.accountingMappingOptions?.liabilityAccountOptions?.forEach(
          (element) => {
            tempLiabilityOptions.push({
              ...element,
              value: element.id,
              label: element.name,
            });
          }
        );

        objList?.savingsProductData?.penaltyOptions?.forEach((element) => {
          tempPenaltyOptions.push({
            value: element.id,
            label: element.name,
          });
        });
        // ====== PRODUCT INFORMATION LOV =======
        setProductCategoryOptions(tempProductCategory);
        setCurrencyOptions(tempCurrency);
        setExternalIdentifiers(tempExternalIdentifier);

        setKycLevelOptions(tempKyc);

        setIssueTypeOptions(tempIssueType);
        setBondTypeOptions(tempBondType);
        setIssuerNameOptions(tempIssuerName);
        setIssuerTypeOptions(tempCurrency);
        setCreditRatingOptions(tempCreditRating);
        setCountriesOptions(tempCountries);
        setIssuePriceOptions(tempIssuePrice);
        setCouponRateOptions(tempCouponRate);
        setCouponFrequencyOptions(tempCouponFrequency);
        setMaturityDateOptions(tempMaturityDate);
        setAmmortizationOptions(tempAmmortization);
        setInterestCalculationBasisOptions(tempInterestCalculationBasis);
        setInterestStartDateOptions(tempInterestStartDate);
        setFirstCouponDate(tempFirstCouponDate);
        setInterestPaymentModeOptions(tempInterestPaymentMode);
        setWitholdingTaxOptions(tempWitholdingTax);
        setAssetAccountOptions(tempAssetOptions);
        setIncomeAccountOptions(tempFeeIncomeAccount);
        setEquityAccountOptions(tempEquityOptions);
        setUseCases(tempUseCase);
        setCustomerSegmentOptions(tempCustomerSegmentOptions);
        setTransactionRestriction(temptransactionRestriction);
        setStatementCycleOptions(tempStatementCycleOptions);
        setDebitAndcreditGlAccount(tempDebitAndcreditGlAccount);
        setDigitsAfterDecimal(tempDigitsAfterDecimal);
        setFeesIncomeOptions(tempFeeIncomeAccount);
        setTransferChargesOptions(tempTransferCharges);
        setSuspenseAccountOption(tempSuspenseAccount);
        setWalletLiabiltyAccountOption(tempWalletLiabilityAccount);
        setProductTypeEnum(tempProductType);
        setIsLoading(false);
        setChargesOptions(tempChargesOptions);
        setExpenseAccountOptions(tempExpenseOptions);
        setLiabilityAccountOptions(tempLiabilityOptions);
        setPaymentTypeOptions(tempPaymentTypeOptions);

        // dummt data
        // setCheckedPOS(tempCurrency);

        // setChargesOption(tempChargesOption);
      }
    });
  }

  function getWalletById() {
    let body = { session };
    setIsLoading(true);

    const url = `${apiConfig.Wallet}/${selectedBranchKey}`;

    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err?.errors[0]?.defaultUserMessage);
        setIsLoading(false);
        return;
      }

      setWalletData(res);

      const walletData = res;

      console.log(walletData.externalIdentifiers);

      // Set switches
      setCheckedActivateWallet(!!walletData.activateWallet);
      setCheckedAllowTokenization(!!walletData.tokenisationEnabled);
      setCheckedAllowSubWallet(!!walletData.subwalletEnabled);
      setCheckedInterestBearing(
        walletData.savingsProductData.nominalAnnualInterestRate !== null &&
          walletData.savingsProductData.nominalAnnualInterestRate !== undefined
      );
      setIsDormancyTrackingActive(
        !!walletData.savingsProductData.isDormancyTrackingActive
      );

      setSelectedCurrencySymbol(
        walletData.savingsProductData.currency.displaySymbol
      );

      console.log(walletData.savingsProductData.accountingMappings);

      // Handle channelAccess
      const channelAccess = walletData.channelAccess || [];
      const initialChannelValues = {};

      const formattedCharges = (
        walletData.savingsProductData.charges || []
      ).map((formValues) => ({
        key: formValues?.id,
        id: formValues?.id,
        name: formValues?.name,
        type: formValues?.chargeCalculationType.value,
        collectedOn: formValues?.chargeTimeType.value,
        amountToUse: formValues?.amount,
        amount: (
          <Statistic
            value={formValues?.amount}
            precision={2}
            valueStyle={{ fontSize: "16px" }}
          />
        ),
      }));

      channelAccess.forEach((item) => {
        const isEnabled = item.multiFactorAuth ? 0 : 1; // Convert true → 0, false → 1

        switch (item.channel) {
          case "MOBILE_APP":
            setCheckedMobileApp(true);
            initialChannelValues["mobileAppLimit"] = item.transactionLimit;
            initialChannelValues["mobileAppMultiFactorAuthentication"] =
              isEnabled;
            break;
          case "USSD":
            setCheckedUSSD(true);
            initialChannelValues["ussdLimit"] = item.transactionLimit;
            initialChannelValues["ussdMultiFactorAuthentication"] = isEnabled;
            break;
          case "WEB_PORTAL":
            setCheckedWebPortal(true);
            initialChannelValues["webPortalLimit"] = item.transactionLimit;
            initialChannelValues["webPortalMultiFactorAuthentication"] =
              isEnabled;
            break;
          case "ATM":
            setCheckedATM(true);
            initialChannelValues["atm"] = item.transactionLimit;
            initialChannelValues["atmMultiFactorAuthentication"] = isEnabled;
            break;
          case "POS":
            setCheckedPOS(true);
            initialChannelValues["posGL"] = item.transactionLimit;
            initialChannelValues["posMultiFactorAuthentication"] = isEnabled;
            break;
          case "API":
            setCheckedAPI(true);
            initialChannelValues["apiGL"] = item.transactionLimit;
            initialChannelValues["apiMultiFactorAuthentication"] = isEnabled;
            break;
          case "QR_CODE":
            setCheckedQRCode(true);
            initialChannelValues["qrCodeGL"] = item.transactionLimit;
            initialChannelValues["qrCodeMultiFactorAuthentication"] = isEnabled;
            break;
          default:
            break;
        }
      });

      form.setFieldsValue({
        ...walletData,
        ...initialChannelValues,

        savingsReferenceAccountId:
          walletData?.savingsProductData.accountingMappings
            ?.savingsReferenceAccount.id,
        overdraftPortfolioControlId:
          walletData.savingsProductData.accountingMappings
            ?.overdraftPortfolioControl.id,
        savingsControlAccountId:
          walletData.savingsProductData.accountingMappings
            ?.savingsControlAccount.id,

        incomeFromInterestId:
          walletData.savingsProductData.accountingMappings?.incomeFromInterest
            .id,

        incomeFromPenaltyAccountId:
          walletData.savingsProductData.accountingMappings
            ?.incomeFromPenaltyAccount.id,

        incomeFromFeeAccountId:
          walletData.savingsProductData.accountingMappings?.incomeFromFeeAccount
            .id,

        escheatLiabilityId: walletData?.savingsProductData?.accountingMappings
          ?.escheatLiabilityAccount
          ? walletData?.savingsProductData?.accountingMappings
              ?.escheatLiabilityAccount?.id
          : "-",

        transfersInSuspenseAccountId:
          walletData.savingsProductData.accountingMappings
            ?.transfersInSuspenseAccount.id,

        interestOnSavingsAccountId:
          walletData.savingsProductData.accountingMappings
            ?.interestOnSavingsAccount.id,

        writeOffAccountId:
          walletData.savingsProductData.accountingMappings?.writeOffAccount.id,

        // Properly format dates
        startDate: walletData.startDate ? dayjs(walletData.startDate) : null,
        endDate: walletData.endDate ? dayjs(walletData.endDate) : null,

        // Flatten nested fields
        name: walletData.savingsProductData.name,
        shortName: walletData.savingsProductData.shortName,
        productTypeEnum:
          walletData.productTypeEnum?.id ?? walletData.productTypeEnum,
        description: walletData.savingsProductData.description,
        currencyCode: walletData.savingsProductData.currency.code,
        nominalAnnualInterestRate:
          walletData.savingsProductData.nominalAnnualInterestRate,
        minBalanceForInterestCalculation:
          walletData.savingsProductData.minBalanceForInterestCalculation,
        lockinPeriodFrequency:
          walletData.savingsProductData.lockinPeriodFrequency,
        daysToDormancy: walletData.savingsProductData.daysToDormancy,
        daysToEscheat: walletData.savingsProductData.daysToEscheat,
        daysToInactive: walletData.savingsProductData.daysToInactive,
        useCases: (walletData.useCases || []).map((item) => item.id),
        transactionRestriction: (walletData.transactionRestrictions || []).map(
          (item) => item.id
        ),
        customerSegment: (walletData.customerSegments || []).map(
          (item) => item.id
        ),
        statementCycle: (walletData.statementCycles || []).map(
          (item) => item.id
        ),
        externalIdEnum:
          walletData.externalIdEnum?.id ?? walletData.externalIdEnum,
        minSubwallet: Number(walletData.minSubwallet) || undefined,
        maxSubwallet: Number(walletData.maxSubwallet) || undefined,
        customerSegmentOptions: walletData.customerSegment,
      });

      if (walletData.savingsProductData.currency.code) {
        onChangeCurrency(walletData.savingsProductData.currency.code);
      }

      console.log(walletData.savingsProductData.currency.code);
      console.log(
        walletData?.savingsProductData.accountingMappings
          ?.savingsReferenceAccount.id
      );

      setChargeTableSource(formattedCharges);
      setIsLoading(false);
    });
  }

  const handleClose = () => {
    setSuccessModalVisible(false);
    setWarningModalVisible(false);
  };

  const handleRadioCheck = (e) => {
    const { name, value, checked } = e.target;
    setAccountingRuleCheck(value);
    setRadioCheck(checked);
  };

  const stepTitles = [
    "Product Information",
    "Customer Eligibility",
    "Account Parameters",
    "Fees & Charges",
    "Channels & Access",
    "Ledger & Accounting Setup",
    "Preview",
  ];

  const onChange = (value) => {
    setCurrent(value);
  };

  const nextButtonClick = () => {
    form.submit();
  };

  const prevButtonClick = () => {
    setCurrent(current - 1);
  };

  function onCancel() {
    navigate("/walletProduct", { replace: false });
  }

  const onFinishProductInformationForm = (values) => {
    values.activateWallet = checkedActivateWallet;
    values.tokenisationEnabled = checkedAllowTokenization || false;
    values.subwalletEnabled = checkedAllowSubWallet || false;

    values.minSubwallet = Number(values.minSubwallet) || 1;
    values.maxSubwallet = Number(values.maxSubwallet) || 1;

    values.startDate = values.startDate
      ? BOM.DateTime(values.startDate, "only-date")
      : values.startDate;
    values.endDate = values.endDate
      ? BOM.DateTime(values.endDate, "only-date")
      : values.endDate;

    console.log(values);

    const enrichedValues = { ...values };

    setFormData({
      ...formData,
      productInformation: enrichedValues,
    });

    setCurrent(current + 1);
  };

  const onFinishCustomerEligibilityForm = (values) => {
    console.log(values);
    const selectFields = [
      { key: "kycLevel", options: kycLevelOptions },
      { key: "transactionRestriction", options: transactionRestriction },
      { key: "customerSegment", options: customerSegmentOptions },
    ];

    const enrichedValues = { ...values };

    console.log(enrichedValues);
    setFormData({ ...formData, customerEligibility: enrichedValues });

    setCurrent(current + 1);
  };

  const onFinishAccountParametersForm = (values) => {
    console.log(values);
    values.interestBearing = checkedInterestBearing;
    values.isDormancyTrackingActive = isDormancyTrackingActive;

    values.maturityDate = values.maturityDate
      ? BOM.DateTime(values.maturityDate, "only-date")
      : values.maturityDate;

    values.nominalAnnualInterestRate =
      Number(values.nominalAnnualInterestRate) || 0;
    values.minBalanceForInterestCalculation =
      Number(values.minBalanceForInterestCalculation) || 0;
    const selectFields = [
      { key: "statementCycle", options: statementCycleOptions },
    ];

    const enrichedValues = { ...values };

    setFormData({ ...formData, accountParameters: enrichedValues });
    setCurrent(current + 1);
  };

  const onFinishChannelsAndAccessForm = (values) => {
    const channels = [
      {
        key: "MOBILE_APP",
        check: checkedMobileApp,
        limitKey: "mobileAppLimit",
        authKey: "mobileAppMultiFactorAuthentication",
      },
      {
        key: "USSD",
        check: checkedUSSD,
        limitKey: "ussdLimit",
        authKey: "ussdMultiFactorAuthentication",
      },
      {
        key: "WEB_PORTAL",
        check: checkedWebPortal,
        limitKey: "webPortalLimit",
        authKey: "webPortalMultiFactorAuthentication",
      },
      {
        key: "ATM",
        check: checkedATM,
        limitKey: "atm",
        authKey: "atmMultiFactorAuthentication",
      },
      {
        key: "POS",
        check: checkedPOS,
        limitKey: "posGL",
        authKey: "posMultiFactorAuthentication",
      },
      {
        key: "API",
        check: checkedAPI,
        limitKey: "apiGL",
        authKey: "apiMultiFactorAuthentication",
      },
      {
        key: "QR_CODE",
        check: checkedQRCode,
        limitKey: "qrCodeGL",
        authKey: "qrCodeMultiFactorAuthentication",
      },
    ];

    const channelAndAccess = channels
      .filter((c) => c.check)
      .map((c) => ({
        channel: c.key,
        transactionLimit: values[c.limitKey] || 0,
        multiFactorAuth: values[c.authKey] === 0, // 0 = enabled → true
      }));

    console.log("Final Data to Save:", channelAndAccess);

    setFormData({ ...formData, channelsAndAccess: channelAndAccess });
    setCurrent(current + 1);
  };

  const onChangeCurrency = (currencyParam) => {
    console.log(currencyParam);
    console.log(currencyOptions);

    const selectedCurrency = currencyOptions.find(
      (item) => item.value === currencyParam
    );

    console.log(selectedCurrency);

    if (selectedCurrency) {
      setSelectedCurrencySymbol(selectedCurrency.symbol);
    } else {
      setSelectedCurrencySymbol(""); // reset if not found
    }

    const chargeForTableData = chargesOptions.filter(
      (item) => item.currencyCode === currencyParam
    );

    setChargeBasedOnCurrencyList([...chargeForTableData]);

    // 4. Reset selected chargeId
    form.setFieldsValue({
      chargeId: "",
    });

    const filteredAssetAccounts = assetAccountOptions.filter(
      (item) => item.currencyCode === currencyParam
    );
    const filteredIncomeAccounts = incomeAccountOptions.filter(
      (item) => item.currencyCode === currencyParam
    );
    const filteredExpenseAccount = expenseAccountOptions.filter(
      (item) => item.currencyCode === currencyParam
    );
    const filteredEquityAccount = equityAccountOptions.filter(
      (item) => item.currencyCode === currencyParam
    );
    const filteredLiabilityAccount = liabilityAccountOptions.filter(
      (item) => item.currencyCode === currencyParam
    );

    setFilteredLiabilityAccount(filteredLiabilityAccount);
    setFilteredEquityAccount(filteredEquityAccount);
    setFilteredExpenseAccount(filteredExpenseAccount);
    setFilteredAssetAccounts(filteredAssetAccounts);
    setFilteredIncomeAccounts(filteredIncomeAccounts);
  };

  const onFinishChargeForm = (values) => {
    let tempChargeArray = [];
    chargeTableSource.forEach((element, index) => {
      tempChargeArray.push({
        id: element.id,
      });
    });

    values.charges = tempChargeArray;

    delete values.chargeId;

    console.log(values);
    setFormData({
      ...formData,
      charges: values.charges,
    });
    setCurrent(current + 1);
  };

  const onFinishAccountForm = (values) => {
    let tempPaymentChannelToFundSourceMappingsArray = [];
    let tempFeeToIncomeAccountMappingsArray = [];
    let tempPenaltyToIncomeAccountMappingsArray = [];

    configureFundTableSource.forEach((element, index) => {
      tempPaymentChannelToFundSourceMappingsArray.push({
        paymentTypeId: element.paymentTypeId,
        fundSourceAccountId: element.fundSourceAccountId,
      });
    });

    mapFeeTableSource.forEach((element, index) => {
      tempFeeToIncomeAccountMappingsArray.push({
        chargeId: element.chargeId,
        incomeAccountId: element.incomeAccountId,
      });
    });

    mapPenaltyTableSource.forEach((element, index) => {
      tempPenaltyToIncomeAccountMappingsArray.push({
        paymentTypeId: element.paymentTypeId,
        fundSourceAccountId: element.fundSourceAccountId,
      });
    });

    values.paymentChannelToFundSourceMappings =
      tempPaymentChannelToFundSourceMappingsArray;
    values.feeToIncomeAccountMappings = tempFeeToIncomeAccountMappingsArray;
    values.penaltyToIncomeAccountMappings =
      tempPenaltyToIncomeAccountMappingsArray;

    console.log(values);
    setFormData({
      ...formData,
      ...values,
      account: values,
      paymentChannelToFundSourceMappings:
        values.paymentChannelToFundSourceMappings,
      feeToIncomeAccountMappings: values.feeToIncomeAccountMappings,
      penaltyToIncomeAccountMappings: values.penaltyToIncomeAccountMappings,
    });
    setCurrent(current + 1);
  };

  const forms = [
    <ProductInformationForm
      onFinish={onFinishProductInformationForm}
      current={current}
      setCurrent={setCurrent}
      onChangeCurrency={onChangeCurrency}
      initialValues={{
        currency: "NGN",
        ...formData.productInformation,
      }}
      productCategoryOptions={productCategoryOptions}
      currencyOptions={currencyOptions}
      issueTypeOptions={issueTypeOptions}
      bondTypeOptions={bondTypeOptions}
      onCurrencyChange={setCurrency}
      form={form}
      checkedActivateWallet={checkedActivateWallet}
      checkedAllowTokenization={checkedAllowTokenization}
      checkedAllowSubWallet={checkedAllowSubWallet}
      setCheckedActivateWallet={setCheckedActivateWallet}
      setCheckedAllowTokenization={setCheckedAllowTokenization}
      setCheckedAllowSubWallet={setCheckedAllowSubWallet}
      productTypeEnum={productTypeEnum}
      useCases={useCases}
      externalIdentifiers={externalIdentifiers}
    />,

    <CustomerEligibilityForm
      onFinish={onFinishCustomerEligibilityForm}
      current={current}
      setCurrent={setCurrent}
      initialValues={formData.customerEligibility}
      issuerNameOptions={issuerNameOptions}
      issuerTypeOptions={issuerTypeOptions}
      transactionRestriction={transactionRestriction}
      creditRatingOptions={creditRatingOptions}
      countriesOptions={countriesOptions}
      form={form}
      kycLevelOptions={kycLevelOptions}
      customerSegmentOptions={customerSegmentOptions}
    />,

    <AccountParametersForm
      selectedCurrencySymbol={selectedCurrencySymbol}
      onFinish={onFinishAccountParametersForm}
      current={current}
      setCurrent={setCurrent}
      initialValues={formData.bondFeatures}
      form={form}
      issuePriceOptions={issuePriceOptions}
      couponRateOptions={couponRateOptions}
      couponFrequencyOptions={couponFrequencyOptions}
      maturityDateOptions={maturityDateOptions}
      ammortizationOptions={ammortizationOptions}
      checkedInterestBearing={checkedInterestBearing}
      setCheckedInterestBearing={setCheckedInterestBearing}
      setIsDormancyTrackingActive={setIsDormancyTrackingActive}
      isDormancyTrackingActive={isDormancyTrackingActive}
      statementCycleOptions={statementCycleOptions}
    />,

    <ChargeForm
      onFinish={onFinishChargeForm}
      form={form}
      chargesOptions={chargeBasedOnCurrencyList}
      userData={userData}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      chargeTableSource={chargeTableSource}
      setChargeTableSource={setChargeTableSource}
      initialValues={formData?.charges}
    />,

    <ChannelsAndAccessForm
      onFinish={onFinishChannelsAndAccessForm}
      selectedCurrencySymbol={selectedCurrencySymbol}
      current={current}
      setCurrent={setCurrent}
      initialValues={{
        mobileAppMultiFactorAuthentication: "Disable",
        ussdMultiFactorAuthentication: "Disable",
        webPortalLimit: "Disable",
        webPortalMultiFactorAuthentication: "Disable",
        atmMultiFactorAuthentication: "Disable",
        posMultiFactorAuthentication: "Disable",
        apiMultiFactorAuthentication: "Disable",
        qrCodeMultiFactorAuthentication: "Disable",
        ...formData.channelsAndAccess,
      }}
      checkedMobileApp={checkedMobileApp}
      checkedUSSD={checkedUSSD}
      checkedWebPortal={checkedWebPortal}
      checkedATM={checkedATM}
      checkedPOS={checkedPOS}
      checkedAPI={checkedAPI}
      checkedQRCode={checkedQRCode}
      setCheckedMobileApp={setCheckedMobileApp}
      setCheckedUSSD={setCheckedUSSD}
      setCheckedWebPortal={setCheckedWebPortal}
      setCheckedATM={setCheckedATM}
      setCheckedPOS={setCheckedPOS}
      setCheckedAPI={setCheckedAPI}
      setCheckedQRCode={setCheckedQRCode}
      interestCalculationBasisOptions={interestCalculationBasisOptions}
      interestStartDateOptions={interestStartDateOptions}
      firstCouponDate={firstCouponDate}
      interestPaymentModeOptions={interestPaymentModeOptions}
      form={form}
      multiFactorAuthenticationOptions={multiFactorAuthenticationOptions}
    />,

    <AccountingForm
      onFinish={onFinishAccountForm}
      form={form}
      formData={formData.account}
      accountingRuleCheck={accountingRuleCheck}
      setAccountingRuleCheck={setAccountingRuleCheck}
      showAdvancedAccounting={showAdvancedAccounting}
      setShowAdvancedAccounting={setShowAdvancedAccounting}
      handleRadioCheck={handleRadioCheck}
      assetAccountOptions={filteredAssetAccounts}
      incomeAccountOptions={filteredIncomeAccounts}
      expenseAccountOptions={filteredExpenseAccount}
      equityAccountOptions={filteredEquityAccount}
      liabilityAccountOptions={filteredLiabilityAccount}
      paymentTypeOptions={paymentTypeOptions}
      charges={charges}
      penaltyOptions={penaltyOptions}
      userData={userData}
      isLoading={isLoading}
      setIsLoading={setIsLoading}
      configureFundTableSource={configureFundTableSource}
      setConfigureFundTableSource={setConfigureFundTableSource}
      mapFeeTableSource={mapFeeTableSource}
      setMapFeeTableSource={setMapFeeTableSource}
      mapPenaltyTableSource={mapPenaltyTableSource}
      setMapPenaltyTableSource={setMapPenaltyTableSource}
      setChargesValue={setChargesValue}
      fundCount={fundCount}
      setFundCount={setFundCount}
      feeCount={feeCount}
      setFeeCount={setFeeCount}
      penaltyCount={penaltyCount}
      setPenaltyCount={setPenaltyCount}
      isDormancyTrackingActive={isDormancyTrackingActive}
    />,

    <Preview
      formData={formData}
      useCases={useCases}
      externalIdentifiers={externalIdentifiers}
      customerSegmentOptions={customerSegmentOptions}
      transactionRestriction={transactionRestriction}
      kycLevelOption={kycLevelOptions}
      statementCycleOptions={statementCycleOptions}
      productTypeEnum={productTypeEnum}
      chargeTableSource={chargeTableSource}
    />,
  ];

  console.log(filteredAssetAccounts);

  const isLastStep = current === forms.length - 1;

  console.log(selectedCurrencySymbol);

  const onSubmit = () => {
    const transformedProductInformation = {
      ...formData.productInformation,
    };

    const transformedAccounting = {
      paymentChannelToFundSourceMappings: [
        {
          paymentTypeId: 2,
          fundSourceAccountId: 260,
        },
      ],
      feeToIncomeAccountMappings: [
        {
          chargeId: 38,
          incomeAccountId: 262,
        },
      ],
      penaltyToIncomeAccountMappings: [
        {
          chargeId: 33,
          incomeAccountId: 262,
        },
      ],
    };

    let formValues = {
      ...transformedProductInformation,
      ...formData.accountParameters,
      ...formData.customerEligibility,
      channelAndAccess: formData.channelsAndAccess,
      ...transformedAccounting,
      ...formData.account,
    };

    // Remove unneeded fields
    delete formValues.walletToWalletTransfer;
    delete formValues.walletToBankTransfer;
    delete formValues.maturityDate;
    delete formValues.interestBearing;
    const nonFormValues = {
      digitsAfterDecimal: digitsAfterDecimal,

      interestCompoundingPeriodType:
        walletTemplate?.savingsProductData?.interestCompoundingPeriodType?.id,
      interestPostingPeriodType:
        walletTemplate?.savingsProductData?.interestPostingPeriodType?.id,
      interestCalculationType:
        walletTemplate?.savingsProductData?.interestCalculationType?.id,
      interestCalculationDaysInYearType:
        walletTemplate?.savingsProductData?.interestCalculationDaysInYearType
          ?.id,
      // externalIdEnum:
      //   walletData.externalIdEnum?.id ?? walletData.externalIdEnum,
      // productTypeEnum:
      //   walletData.productTypeEnum?.id ?? walletData.productTypeEnum,
      lockinPeriodFrequencyType: 1,
      accountingRule: 2,
      inMultiplesOf: 0,
      charges: formData.charges,
    };

    const isEditMode = !!selectedBranchKey; // set this somewhere using useParams() or state

    const body = {
      ...formValues,
      ...nonFormValues,
      locale: "en",
      dateFormat: "dd MMMM yyyy",

      method: isEditMode ? "PUT" : "POST",
      // method: "PUT",
      session,
    };

    const url = isEditMode
      ? `${apiConfig.Wallet}/${walletData?.id}`
      : apiConfig.Wallet;

    setIsLoading(true);
    BOM.FetchReqAction(body, url, (err, res) => {
      if (err) {
        BOM.AlertMsg(cnt.DANGER, err.errors[0].defaultUserMessage);
        setIsLoading(false);
      } else {
        BOM.AlertMsg(
          cnt.SUCCESS,
          isEditMode
            ? "Wallet Product Updated Successfully"
            : "Wallet Product Created Successfully"
        );
        setSuccessModalVisible(true);
        navigate("/walletProduct");
      }

      setIsLoading(false);
    });
  };

  return (
    <MainLayout
      pageItems={
        selectedBranchKey
          ? staticConfig.editWalletItems
          : staticConfig.newWalletItems
      }
      onSave={onSubmit}
    >
      <TopContent
        pageTitle={labelConfig.wallet}
        createPageTitle={
          selectedBranchKey ? labelConfig.editWallet : labelConfig.createWallet
        }
      />
      <Spin spinning={isLoading} size="large">
        <div
          style={{
            display: "flex",
            paddingLeft: "44px",
            marginTop: "20px",
            widtth: "100%",
          }}
        >
          {/* Navigation section */}
          <div style={{ width: "288px", padding: "20px 0" }}>
            <Steps
              className="custom-step-style"
              current={current}
              onChange={onChange}
              direction="vertical"
              style={{ height: "723px" }}
              items={[
                {
                  title: <Text strong>Product Information</Text>,
                  disabled: isStepDisabled,
                },
                {
                  title: <Text strong>Customer Eligibility</Text>,
                  disabled: isStepDisabled,
                },
                {
                  title: <Text strong>Account Parameters</Text>,
                  disabled: isStepDisabled,
                },
                {
                  title: <Text strong>Fees & Charges</Text>,
                  disabled: isStepDisabled,
                },
                {
                  title: <Text strong>Channels & Access</Text>,
                  disabled: isStepDisabled,
                },
                {
                  title: <Text strong>Ledger & Accounting Setup</Text>,
                  disabled: isStepDisabled,
                },
                {
                  title: <Text strong>Preview</Text>,
                  disabled: isStepDisabled,
                },
              ]}
            />
          </div>

          {/* Form section */}
          <Card
            style={{
              borderRadius: 20,
              width: "100%",
              margin: 0,
              display: "flex",
              flexDirection: "column",
              padding: "0 20px",
              height: `${current === forms.length - 1 ? "723px" : "100%"}`,
              overflowY: `${current === forms.length - 1 ? "auto" : "hidden"}`,
            }}
          >
            <div style={{ flexGrow: 1 }}>{forms[current]}</div>

            {/* Button Section (at bottom) */}
            <div
              style={{
                paddingTop: 30,
                borderRadius: 20,
              }}
            >
              <Flex justify="end" gap="30px" align="end">
                {current === 0 && (
                  <Button
                    style={{
                      backgroundColor: "white",
                      borderRadius: 8,
                      border: "1px solid #D0D5DD",
                      padding: "20px 15px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                    colortext="#344054"
                    className="previous-button"
                    onClick={() => setWarningModalVisible(true)}
                  >
                    Go Back
                  </Button>
                )}
                {current > 0 && (
                  <Button
                    style={{
                      backgroundColor: "white",
                      borderRadius: 8,
                      border: "1px solid #D0D5DD",
                      padding: "20px 15px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                    colortext="#344054"
                    className="previous-button"
                    onClick={prevButtonClick}
                  >
                    Previous
                  </Button>
                )}
                {!isLastStep && (
                  <Button
                    style={{
                      backgroundColor: "#BA24D5",
                      color: "white",
                      border: "1px solid #BA24D5",
                      borderRadius: 8,
                      padding: "20px 15px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                    onClick={nextButtonClick}
                  >
                    Next - {stepTitles[current + 1]}
                  </Button>
                )}
                {BOM.HasPermission("CREATE_BOND") && isLastStep && (
                  <Button
                    style={{
                      backgroundColor: "#BA24D5",
                      color: "white",
                      border: "1px solid #BA24D5",
                      borderRadius: 8,
                      padding: "20px 15px",
                      fontSize: "16px",
                      fontWeight: "600",
                    }}
                    onClick={onSubmit}
                  >
                    {selectedBranchKey ? "Edit Product" : "Create Product"}
                  </Button>
                )}
              </Flex>
            </div>
          </Card>
        </div>
      </Spin>

      {/* Success Modal */}
      <FeedbackModal
        visible={successModalVisible}
        type="success"
        onPrimaryAction={handleClose}
        onSecondaryAction={() => {
          onCancel();
        }}
        onClose={handleClose}
      />

      {/* Warning Modal */}
      <FeedbackModal
        visible={warningModalVisible}
        type="warning"
        onPrimaryAction={() => {
          onCancel();
        }}
        onSecondaryAction={() => {
          handleClose();
        }}
        onClose={handleClose}
      />
    </MainLayout>
  );
};

const mapStateToProps = (state) => ({
  userData: state.AuthenticationData.userData,
  rightBtn: state.RightSideBtn,
});

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(NewWallet);
